<template>
  <div id="app">
    <div id="menuContainer" v-show="!showNav"></div>
    <router-view />
  </div>
</template>

<script>
import APIS from '@/apis/login.js'
import updateMenuService from "@/common/updateMenu.js"
export default {
  data() {
    return {
      userName: "",
      realmName: this.$realm
    }
  },
  computed: {
    // 404页面不展示导航菜单
    showNav() {
      return this.$store.state.is404
    }
  },
  created() {
    this.userName = this.$keycloak.tokenParsed.preferred_username
    this.userName ? this.getInfo() : null
  },
  methods: {
    async getInfo () {
      let { status, data } = await APIS.getPortalAccountInfo(
        this.realmName,
        this.userName
      )
      if ( status === 0 && data ) {
        localStorage.setItem('locale', data.locale || 'zh-CN')
        this.$store.commit("change_language", data.locale || 'zh-CN')
        updateMenuService(this.$keycloak)
      }
    }
  }
}
</script>

<style lang="scss">
.el-message{
  z-index: 10003!important;
}
</style>
